import { cn } from '../lib/utils'

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('animate-pulse rounded-md bg-muted', className)}
      {...props}
    />
  )
}

function SeparatorSkeleton() {
  return <Skeleton className="h-[68px] w-full rounded-lg p-6" />
}

export { Skeleton, SeparatorSkeleton }
